const {detect} = require("detect-browser");
const {isVersion} = require("helpers/version");

class Browser {

	get detection() {
		return this._detection || (this._detection = detect());
	}

	get name() {
		return this.detection.name;
	}

	get version() {
		return this.detection.version;
	}

	isVersion(version) {
		return (version == null) || isVersion(this.detection.version, version);
	}

	ie(version = null) {
		return (this.detection.name === "ie") && this.isVersion(version);
	}

}

module.exports = new Browser();